/* tslint:disable */ /* eslint-disable */
import * as Types from '../../../models/generated/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateSurveyMutationVariables = Types.Exact<{
  surveyId: Types.Scalars['Int'];
  name: Types.Scalars['String'];
  description?: Types.InputMaybe<Types.Scalars['String']>;
  questionIds: Array<Types.Scalars['Int']> | Types.Scalars['Int'];
}>;


export type UpdateSurveyMutation = { editSurvey: { id: number } };


export const UpdateSurveyDocument = gql`
    mutation UpdateSurvey($surveyId: Int!, $name: String!, $description: String, $questionIds: [Int!]!) {
  editSurvey(surveyId: $surveyId, name: $name, description: $description, questionIds: $questionIds) {
    id
  }
}
    `;

/**
 * __useUpdateSurveyMutation__
 *
 * To run a mutation, you first call `useUpdateSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSurveyMutation, { data, loading, error }] = useUpdateSurveyMutation({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      questionIds: // value for 'questionIds'
 *   },
 * });
 */
export function useUpdateSurveyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSurveyMutation, UpdateSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSurveyMutation, UpdateSurveyMutationVariables>(UpdateSurveyDocument, options);
      }
export type UpdateSurveyMutationHookResult = ReturnType<typeof useUpdateSurveyMutation>;
export type UpdateSurveyMutationResult = Apollo.MutationResult<UpdateSurveyMutation>;
export type UpdateSurveyMutationOptions = Apollo.BaseMutationOptions<UpdateSurveyMutation, UpdateSurveyMutationVariables>;